var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"rf-button",class:[_vm.variant, _vm.size, _vm.extraClass],attrs:{"href":_vm.type === 'submit' ? '' : '#',"type":_vm.type,"title":_vm.bTitle},on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }